import { Button, Dialog, DialogContent, Divider } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import LegalPersonCRUDTable from "../Crud/Tables/LegalPersonCRUDTable";
import PersonCRUDTable from "../Crud/Tables/PersonCRUDTable";

export default function PersonField({
                                          label,
                                          value,
                                          onChange,
                                          extraFilter,
                                          disabled,
                                          sx,
                                          object
                                      }) {
    const [open, setOpen] = useState(false);
    const [name, setName] = useState('')

    useEffect(() => {
        if (!object)
            return;
    }, [object]);

    return (
        <>
            <Grid container spacing={1} >
                {/* Field Line */}
                <Grid item xs={12}>
                    <Toolbar sx={sx}>
                        <Typography style={{ fontWeight: "bold", width: "50%" }}>
                            {label || "Физ лицо"}:{" "}
                        </Typography>
                        <Typography>
                            {object?.fullName || name || `id физ лица: ${value || 'не указано'}`}
                        </Typography>
                        <Button disabled={disabled} onClick={() => setOpen(true)} variant={"outlined"} style={{ marginLeft: "10px", outline: 'none' }}>Выбрать</Button>
                    </Toolbar>
                </Grid>
            </Grid>
            {/* Dialog Select*/}
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                PaperProps={{sx: {maxHeight: '85%'}}}
                maxWidth={"80%"}
            >
                <DialogTitle>Выбор физ. лица</DialogTitle>
                <Divider />
                <DialogContent>
                    <PersonCRUDTable
                        extraFilter={extraFilter}
                        onClickCreateButton={undefined} // что бы не показывать кнопку создания
                        onRowClick={(record, rowIndex) => {
                            onChange(record);
                            setName(record.fullName)
                            setOpen(false);
                        }}
                    />
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant={"text"}
                        style={{ marginLeft: "auto" }}
                        onClick={() => setOpen(false)}
                    >
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
